export default [
    {
        path: "",
        name: "home",
        component: "spaceHomePage",
    },
    {
        path: "/moi",
        name: "me",
        component: "spaceMePage",
    },
    {
        path: "projet/:id_projet",
        name: "project",
        component: "spaceProjetPage",
    },
    {
        path: "devis/:id_devis",
        name: "devis",
        component: "spaceDevisPage",
    },
    {
        path: "commande/:id_devis",
        name: "commande",
        component: "spaceCommandePage",
    },
    {
        path: "parrain",
        name: "parrain",
        component: "spaceParrainPage",
    },
    {
        path: "apres-vente",
        name: "apres-vente",
        component: "spaceApresVentePage",
    },
    {
        path: "comptable",
        name: "comptable",
        component: "spaceComptablePage",
    },
]
